export default {
    green: '#004857',
    greenLight: '#489EAC',
    greenLight2: '#d9e0e6',
    orange: '#FF5C00',
    purple: '#7E3F98',
    greyLight: '#F5F5F5',
    red: 'red',
    redLight: '#f7abab',
    yellow: '#F9B92C',

    white: '#FFFFFF',
    black: '#000000',
    green_100: '#E5FEDC',
    green_400: '#11A643',
    red_100: '#FEDFDC',
    red_400: '#DA0000',
    red_800: '#800E0E',
    grey_100: '#F5F5F5',
    grey_200: '#E6E8F0',
    grey_400: '#D7D7D7',
    grey_600: '#CCCCCC',
    turquoise_100: '#E2F2F4',
    turquoise_400: '#8ACDD8',
    turquoise_500: '#004B57',
    turquoise_600: '#023B44',
    orange_100: '#FBCBB0',
    orange_300: '#EEA074',
    orange_500: '#FF5C00',
    orange_600: '#AD4001',
    purple_100: '#DEA8F4',
    purple_400: '#BD65E1',
    purple_800: '#551A6D',
};
